<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Intro',

    metaInfo: { title: 'Mot du président' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'content',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'pro',
      },
    },
  }
</script>
